import type { RopCardBase } from "../../dashboard/models/dados-indicadores.model";

export type RopCard3003LiveSingleLineDiagram = RopCardBase & {
  componentOperationalStatuses: ComponentOperationalStatus[];
};

export const enum OperationalStatus {
  Unknown,
  On,
  Off,
  NoTelemetry,
}

export type ComponentOperationalStatus = {
  identifier: string;
  operationalStatus: OperationalStatus;
};
